import { get } from 'lodash'

class Response {
  constructor (data) {
    Object.assign(this, data)
  }

  /**
   * Get response data
   *
   * @param {string|Array} keys - Response data keys
   * @param {*} fallback - Fallback value
   */
  get (keys, fallback = null) {
    if (!Array.isArray(keys)) {
      return get(this, keys, fallback)
    }

    return keys.reduce((carry, key) => {
      let name = this._getName(key)

      return Object.assign(carry, { [name]: get(this, key, fallback) })
    }, {})
  }

  /**
   * Get the last section of a string which is not 'data'
   *
   * @param {string} key
   * @returns {string}
   * @private
   */
  _getName (key) {
    let path = key.split('.')

    while (path.length > 1 && path[path.length - 1] === 'data') {
      path.pop()
    }

    return path.pop()
  }
}

const transformResponse = function (data) {
  if (typeof data === 'string') {
    try {
      data = new Response(JSON.parse(data))
    } catch (e) { /* Ignore */ }
  }

  return data
}

export { Response, transformResponse }
